const KST_DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Asia/Seoul',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export const toDisplayMs = (ms) => Math.floor(ms / 10) * 10;

/** STOP 시 화면·stop2 API·서명 평문에 공통으로 쓰는 경과 초(소수 둘째 자리 절사) */
export const toClientElapsedSec = (rawMs) => {
  const displayMs = toDisplayMs(rawMs);
  const truncatedSec = Math.floor((displayMs / 1000) * 100) / 100;
  return truncatedSec.toFixed(2);
};

export const getTodayKstKey = () => {
  const parts = KST_DATE_FORMATTER.formatToParts(new Date());
  const y = parts.find((part) => part.type === 'year')?.value ?? '0000';
  const m = parts.find((part) => part.type === 'month')?.value ?? '00';
  const d = parts.find((part) => part.type === 'day')?.value ?? '00';
  return `${y}-${m}-${d}`;
};

export const formatTimer = (ms) => {
  const safeMs = Math.max(0, ms);
  const minutes = Math.floor(safeMs / 60000);
  const seconds = Math.floor((safeMs % 60000) / 1000);
  const centiseconds = Math.floor((safeMs % 1000) / 10);
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}.${String(centiseconds).padStart(2, '0')}`;
};

export const formatSecondsText = (ms) => {
  const truncatedTo2Sec = Math.floor((Math.max(0, ms) / 1000) * 100) / 100;
  return `${truncatedTo2Sec.toFixed(2)}초`;
};
